<template>
  <div>
    <el-card>
      <div class="btn-group">
        <el-button type="primary" @click="handleAddBureau">添加</el-button>
      </div>
      <!-- 表格 -->
      <el-table
        :data="
          bureauList.slice((currentPage - 1) * pagesize, currentPage * pagesize)
        "
        style="width: 100%"
        height="600"
        class="diffrow"
        ref="departmentTable"
        @selection-change="handleSelectionChange"
        :default-sort="{ prop: 'departmentId' }"
        :tree-props="{ children: 'children' }"
        row-key="departmentId"
      >
        <el-table-column type="selection" width="55" fixed />
        <template v-for="column in bureauTable" :key="column.label">
          <el-table-column
            :prop="column.prop"
            :label="column.label"
            width="220"
            :formatter="formatter"
          >
          </el-table-column>
        </template>
        <el-table-column label="操作" width="200">
          <template #default="scope">
            <el-button type="text" @click="handleReset(scope.$index, scope.row)"
              >重置密码</el-button
            >
            <el-button type="text" @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-popconfirm
              title="确认删除?"
              @confirm="deleteBureau(scope.$index, scope.row)"
              confirm-button-text="是"
              cancel-button-text="否"
            >
              <template #reference>
                <el-button type="text">删除</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-block">
        <el-pagination
          v-model:current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          v-model:page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="bureauList.length"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>

      <el-dialog v-model="showableComp.addBureau" title="添加部门" width="40%">
        <el-form label-width="120px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="单位名称">
                <el-input v-model="departmentForm.departmentName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属地区">
                <RegionSelect
                  ref="regionSelect"
                  v-model="departmentForm.regionId"
                  @regionId="this.departmentForm.regionId = $event"
                ></RegionSelect>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="机构级别">
                <el-input v-model="departmentForm.level" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="领导">
                <el-input v-model="departmentForm.leader" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="局级管理用户名">
                <el-input
                  v-model="departmentForm.username"
                  placeholder="请输入自定义用户名"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input
                  v-model="departmentForm.remarks"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <p class="tips">*系统将默认创建局级管理账号</p>

          <div class="botton-btn">
            <el-button type="primary" @click="doSubmit">确认</el-button>
            <el-button type="default" @click="doCancel">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import BureauManage from "../api/BureauManage";
export default BureauManage;
</script>

<style scoped lang="scss">
.pagination-block {
  margin-top: 20px;
}

.btn-group {
  text-align: end;
}

.tips {
  text-align: start;
}

.botton-btn {
  text-align: end;
}
</style>